var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.175,
    height: 19.175,
    viewBox: "0 0 19.175 19.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Invoice",
    d: "M367-441.412A9.588,9.588,0,0,1,376.588-451a9.588,9.588,0,0,1,9.587,9.588,9.587,9.587,0,0,1-9.587,9.587A9.587,9.587,0,0,1,367-441.412Zm1.417,0a8.179,8.179,0,0,0,8.17,8.17,8.179,8.179,0,0,0,8.17-8.17,8.179,8.179,0,0,0-8.17-8.17A8.179,8.179,0,0,0,368.418-441.412Zm7.71,5.8v-1.4H373.67a.708.708,0,0,1-.708-.709.708.708,0,0,1,.708-.708h2.457V-440.7h-.611a2.558,2.558,0,0,1-2.555-2.556,2.557,2.557,0,0,1,2.555-2.555h.611v-1.4a.708.708,0,0,1,.708-.708.708.708,0,0,1,.709.708v1.4h1.93a.708.708,0,0,1,.708.708.708.708,0,0,1-.708.708h-1.93v2.277h.611a2.558,2.558,0,0,1,2.555,2.556,2.558,2.558,0,0,1-2.555,2.556h-.611v1.4a.709.709,0,0,1-.709.709A.709.709,0,0,1,376.127-435.608Zm1.417-2.819h.611a1.139,1.139,0,0,0,1.138-1.138,1.139,1.139,0,0,0-1.138-1.138h-.611Zm-3.166-4.832a1.14,1.14,0,0,0,1.138,1.138h.611V-444.4h-.611A1.14,1.14,0,0,0,374.378-443.259Z",
    transform: "translate(-367 451)",
    fill: "#95a7c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceLight);
export default __webpack_public_path__ + "static/media/InvoiceLight.c9b43c62b3f59871b50b295da4f325ad.svg";
export { ForwardRef as ReactComponent };